export const fromGlobalId = (globalId: string): string => {
  try {
    return atob(globalId).split(/:(.+)/)[1];
  } catch (err) {
    return globalId;
  }
};
